// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelay__KeyFacts__Price = require("./PropertyWizardRelay__KeyFacts__Price.bs.js");
var PropertyWizardRelay__KeyFacts__DraftType = require("./PropertyWizardRelay__KeyFacts__DraftType.bs.js");
var PropertyWizardRelayKeyFacts_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFacts_draft_graphql.bs.js");
var PropertyWizardRelay__KeyFacts__RentalData = require("./PropertyWizardRelay__KeyFacts__RentalData.bs.js");
var PropertyWizardRelay__KeyFacts__PropertyType = require("./PropertyWizardRelay__KeyFacts__PropertyType.bs.js");
var PropertyWizardRelay__KeyFacts__StreetAddress = require("./PropertyWizardRelay__KeyFacts__StreetAddress.bs.js");
var PropertyWizardRelayKeyFacts_formState_graphql = require("../../../__generated__/PropertyWizardRelayKeyFacts_formState_graphql.bs.js");

var convertFragment = PropertyWizardRelayKeyFacts_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFacts_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFacts_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFacts_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFacts_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFacts_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFacts_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayKeyFacts_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFacts_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFacts_formState_graphql.node, convertFragment$1, fRef);
}

var FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__KeyFacts(props) {
  var draft = use(props.draft);
  var formState = use$1(props.formState);
  var match = PropertyWizardFormRelay.Context.use();
  var tmp;
  var tmp$1 = match.mode;
  tmp = typeof tmp$1 !== "object" ? JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__DraftType.make, {
          draft: draft.fragmentRefs
        }) : null;
  var match$1 = draft.draftProperty.propertyType;
  var tmp$2;
  tmp$2 = match$1 === "FOR_SALE" ? null : JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__RentalData.make, {
          draft: draft.fragmentRefs,
          stepHasBeenTouched: formState.stepKeyFactsTouched
        });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                tmp,
                JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__StreetAddress.make, {
                      draft: draft.fragmentRefs,
                      formState: formState.fragmentRefs,
                      stepHasBeenTouched: formState.stepKeyFactsTouched,
                      duplicatedProperty: props.duplicatedProperty
                    }),
                JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__Price.make, {
                      draft: draft.fragmentRefs,
                      stepHasBeenTouched: formState.stepKeyFactsTouched
                    }),
                tmp$2,
                JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__PropertyType.make, {
                      draft: draft.fragmentRefs,
                      stepHasBeenTouched: formState.stepKeyFactsTouched
                    })
              ]
            });
}

var DraftType;

var StreetAddress;

var Price;

var RentalData;

var PropertyType;

var make = PropertyWizardRelay__KeyFacts;

exports.DraftType = DraftType;
exports.StreetAddress = StreetAddress;
exports.Price = Price;
exports.RentalData = RentalData;
exports.PropertyType = PropertyType;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
